  import {
    AutocompleteInput,
      BooleanInput,
      Edit,
      FormDataConsumer,
      NullableBooleanInput,
      ReferenceInput,
      required,
      SelectInput,
      SimpleForm,
      TextInput,
    } from 'react-admin';
import SendGridEventsList from './SendgridEventsList';
    
    export const SubscriptionsEdit = () => (
      <Edit>
        <SimpleForm>
          <TextInput source="email" validate={[required()]} />
          <BooleanInput source="active"/>
          <SendGridEventsList />

        </SimpleForm>
      </Edit>
    );
    